import React from 'react';
import {View} from 'react-native';
import { StyleSheet } from 'react-native';

import {PractitionerProfile} from '../../server/types/practitioner-profile.types';

import DoctorConsultationProfile from '../doctor/DoctorConsultationProfile';

interface ConsultationDoctorProfileModalProps {
  practitioner: PractitionerProfile;
  onClose?: () => void;
}

const ConsultationDoctorProfileModal = (
  props: ConsultationDoctorProfileModalProps,
) => {
  

  return (
    <View style={styles.root}>
      <DoctorConsultationProfile
        practitioner={props.practitioner}
        onClose={props.onClose}
      />
    </View>
  );
};

const styles = StyleSheet.create(({
  root: {
    paddingVertical: 24,
    paddingHorizontal: 32,
  },
}));

export default ConsultationDoctorProfileModal;
